import { createSelector } from "reselect";

const queryStringSelector = (state) => state.queryString;

export const selectQueryString = createSelector(
    queryStringSelector,
    (state => state.queryString)
)